module.exports = __webpack_public_path__ + "img/change_term.b367e650.svg";